import { create } from 'zustand';
// import { TermsAndConditionsDTO } from '../types';
import {TermsAndConditionsDTO, TermsAndConditionsType} from "@/shared/api/model";

interface TermsAndConditionsState {
  currentItem: TermsAndConditionsDTO | null;
  selectedType: TermsAndConditionsType | null;
  selectedEntityId: string | null;
  filterActive: boolean;
  
  // Actions
  setCurrentItem: (item: TermsAndConditionsDTO | null) => void;
  setSelectedType: (type: TermsAndConditionsType | null) => void;
  setSelectedEntityId: (entityId: string | null) => void;
  setFilterActive: (active: boolean) => void;
  resetFilters: () => void;
}

export const useTermsAndConditionsStore = create<TermsAndConditionsState>((set) => ({
  currentItem: null,
  selectedType: null,
  selectedEntityId: null,
  filterActive: false,
  
  // Actions
  setCurrentItem: (item) => set({ currentItem: item }),
  setSelectedType: (type) => set({ selectedType: type }),
  setSelectedEntityId: (entityId) => set({ selectedEntityId: entityId }),
  setFilterActive: (active) => set({ filterActive: active }),
  resetFilters: () => set({ 
    selectedType: null,
    selectedEntityId: null,
    filterActive: false
  })
}));
